import React from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import placeHolderImg from "../../Assets/Images/placeholder.png";

const BannerPreview = ({
  image,
  title,
  subtitle,
  updateOpenArrayState,
  sectionId,
}) => {
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="containerPreviewImage mt-3">
      <div className="text-center my-4">
        <img
          src={image ? image : placeHolderImg}
          alt=""
          className="rounded"
          width="100%"
        />
      </div>

      <div className="overlay1" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default BannerPreview;
